module.exports = __webpack_public_path__ + "static/media/google-play.8837f5e2.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/assets/images/google-play.svg
// module id = 993
// module chunks = 11